import { IMunicipality } from "Dashboard/domain/IMunicipality";
import { useEffect, useState } from "react";
import { partnersService } from "../../../services/partner.service";

export function useMunicipalities() {
  const [municipalities, setMunicipalities] = useState<IMunicipality[]>([]);

  useEffect(() => {
    async function getData() {
      const municipalities = await partnersService.getAllMunicipalities();
      setMunicipalities(municipalities);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  return municipalities;
}
